import { render, staticRenderFns } from "./deliverlist.vue?vue&type=template&id=2c85005d&scoped=true"
import script from "./deliverlist.vue?vue&type=script&lang=js"
export * from "./deliverlist.vue?vue&type=script&lang=js"
import style0 from "./deliverlist.vue?vue&type=style&index=0&id=2c85005d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85005d",
  null
  
)

export default component.exports